import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export const searchDebounceTime = 400;

export function searchDebounce<T>(time: number = searchDebounceTime): (source: Observable<T>) => Observable<T> {
   return debounceTime(time);
}
